module.exports = __webpack_public_path__ + "img/icon-none.b77494e5.png";